import '@texas42/design-tokens/tokens.css';
import './styles/app.css';
import { mount } from 'svelte';
import App from './Root.svelte';

const app = mount(App, {
  target: document.getElementById('app')!,
});

export default app;
